var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { VueType, Component } from '../core';
import { ICollectState } from '../../store/CollectState';
import { Prop } from 'vue-property-decorator';
import IconBtn from '../components/IconBtn';
import { dialog } from '../../../common/dialog';
import { IDomState } from '../../store/DomState';
import { DtEid } from '../../../common/reporter';
let CollectTab = class CollectTab extends VueType {
    onDelAllClick() {
        return __awaiter(this, void 0, void 0, function* () {
            // if (window.confirm('确认删除所有收藏记录吗？')) {
            //     this.state.delAllFollow()
            // }
            const { isOK } = yield dialog.confirm({ title: '确认清除所有收藏记录吗？' });
            if (isOK) {
                this.state.delAllFollow();
            }
        });
    }
    render() {
        return <div class="collect_tab_main">
            <div class="collect_tabs">
                {this.state.tabs.map((item, index) => <CollectTabItem tab={item} key={index}></CollectTabItem>)}
            </div>
            {this.state.dataLength > 0 &&
            <IconBtn onClick={this.onDelAllClick} class="collect_clear" text='清除全部' dt-eid={DtEid.BUTTON} dt-params="title=delete_all"></IconBtn>}
        </div>;
    }
};
__decorate([
    ICollectState
], CollectTab.prototype, "state", void 0);
CollectTab = __decorate([
    Component
], CollectTab);
export default CollectTab;
let CollectTabItem = class CollectTabItem extends VueType {
    get isActive() {
        return this.tab === this.state.activeTab;
    }
    get text() {
        return this.tab.name + (this.tab.followList.length ? `(${this.tab.followList.length})` : '');
    }
    onClick() {
        const index = this.state.tabs.findIndex(item => item === this.tab);
        this.state.setActiveIndex(index);
    }
    get style() {
        return this.domState.isMinWidth
            ? { marginRight: '13px' }
            : this.domState.showNum === 4
                ? { marginRight: '30px' }
                : null;
    }
    render() {
        if (txv.login.isLogin()) {
            return <div style={this.style} class={{ collect_tab_active: this.isActive, collect_tab_item: true, pos: true }} onClick={this.onClick} dt-eid={DtEid.TAB} dt-params={`title=${this.tab.name}`}>
            <span>{this.text}</span>
        </div>;
        }
    }
};
__decorate([
    Prop()
], CollectTabItem.prototype, "tab", void 0);
__decorate([
    IDomState
], CollectTabItem.prototype, "domState", void 0);
__decorate([
    ICollectState
], CollectTabItem.prototype, "state", void 0);
CollectTabItem = __decorate([
    Component
], CollectTabItem);
export { CollectTabItem };
